/**
 * @packageDocumentation
 * @module f1/fn
 */

export interface Lift {
  /**
   * Lift a value in to a function for easy use with functor parameters. There are many parameters which
   * require a function to provide a value, this method helps pass values. This supports building
   * purely declarative logic.
   *
   * ```ts
   * f1.and(method, f1.lift(true)) => boolean
   * ```
   *
   * @public
   * @function f1.lift
   * @param val the value to lift for use in functions
   * @example
   *
   * ```ts
   * lift(true) => (() => true)
   * lift(1) => (() => 1)
   * lift(() => 1) => (() => () => 1)
   * ```
   *
   */
  <V>(val: V): () => V;
}

/**
 * @see Lift
 */
export default <V>(val: V): (() => V) => () => val;
